import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import './welcome.css'

const Welcome = ({
  game,
  connectWebSocket,
  thisPlayer,
  setThisPlayer,
  errorMessage,
}) => {
  const [userLoginError, setUserLoginError] = useState('')
  const [roomLoginError, setRoomLoginError] = useState('')
  const {
    register,
    getValues,
    handleSubmit,
    formState: { errors, isValid },
    reset,
  } = useForm({
    defaultValues: {
      username: '',
      roomCode: '',
    },
    mode: 'onChange',
  })

  const formSchema = {
    username: {
      required: {
        value: true,
        message: 'Kullanıcı adı zorunludur.',
      },
      maxLength: {
        value: 12,
        message: 'Kullanıcı adı 12 karakterden uzun olamaz.',
      },
      minLength: {
        value: 4,
        message: 'Kullanıcı adı 4 karakterden kısa olamaz.',
      },
      pattern: {
        value: /^[0-9a-zğüşöçıİĞÜŞÖÇ\s]+$/i,
        message: 'Kullanıcı adı sadece harf ve rakamlardan oluşabilir.',
      },
      transform: (value) => value.trim(),
    },
    roomCode: {
      required: {
        value: true,
        message: 'Oda kodu zorunludur.',
      },
      maxLength: {
        value: 4,
        message: '4 karakter olmalı.',
      },
      minLength: {
        value: 4,
        message: '4 karakter olmalı.',
      },

      pattern: {
        value: /^[0-9a-z\s]+$/i,
        message: 'Sadece harf ve rakam giriniz.',
      },
      transform: (value) => value.trim(),
    },
  }

  //Listen to the button click of Devam and Yeni Oda, and if Yeni Oada is clicked then send a websocket request to ws://6n3k.com/room/new (taam -volkan)

  const handleNew = (e) => {
    // console.log('Yeni Oda button clicked!')
    // console.log(`Value of username input: ${getValues('username')}`)
    let username = getValues('username')
    if (!username) {
      setUserLoginError('Kullanıcı adı giriniz')
    } else {
      setThisPlayer({
        ...thisPlayer,
        name: username,
        ready: false,
        alive: false,
      })
      // console.log('thisPlayer is nassı: ' + thisPlayer.name)
      //game.thisPlayer = { name: getValues('username'), ready: false }

      let url
      if (window.location.href == 'https://6n3k.com/') {
        url = `wss://6n3k.volkan.workers.dev/room/new/${username}`
      } else if (window.location.href == 'http://localhost:3000/') {
        // url = `ws://localhost:8788/api/new/${username}`
        url = `wss://6n3k.pages.dev/api/new/${username}`
      }
      // let url = `wss://6n3k.pages.dev/api/new/${username}`
      // // url = `ws://localhost:8787/room/new/${username}`
      // // url = `wss://6n3kserver.pages.dev/api/new/${username}`
      // url = `wss://6n3k.volkan.workers.dev/room/new/${username}`
      // // url = `ws://localhost:8788/api/new/${username}`
      // console.log(url)
      connectWebSocket(url)
      //setGame({ ...game, state: 'lobby' })
      //websocket(url)
    }
  }
  const handleJoin = (e) => {
    // console.log('Katıl button clicked!')
    // console.log(`Input value: ${getValues('username')}`)
    // game.thisPlayer = { name: getValues('username'), ready: false }

    let username = getValues('username')
    let roomCode = getValues('roomCode')

    if (!username) {
      setUserLoginError('Kullanıcı adı giriniz')
    } else if (!roomCode) {
      setRoomLoginError('Oda kodu giriniz')
    } else {
      setThisPlayer({
        ...thisPlayer,
        name: username,
        ready: false,
        alive: false,
      })
      // console.log('thisPlayer is: ' + thisPlayer.name)
      game.roomCode = getValues('roomCode').toUpperCase().trim()
      // console.log('game.roomCode is: ' + game.roomCode)
      //Check if the roomCode matches the 4 digit base36 code.
      let url
      if (window.location.href == 'https://6n3k.com/') {
        url = `wss://6n3k.volkan.workers.dev/room/${game.roomCode}/${username}`
      } else if (window.location.href == 'http://localhost:3000/') {
        // url = `ws://localhost:8788/room/${game.roomCode}/${username}`
        url = `wss://6n3k.pages.dev/api/${game.roomCode}/${username}`
      }

      // // url = `ws://localhost:8787/room/${game.roomCode}/${username}`
      // // url = `wss://6n3kserver.pages.dev/api/${game.roomCode}/${username}`
      // url = `wss://6n3k.volkan.workers.dev/room/${game.roomCode}/${username}`
      // // url = `ws://localhost:8788/room/${game.roomCode}/${username}`

      connectWebSocket(url)
    }

    //setGame({ ...game, state: 'lobby' })
  }
  // Set the username login error message when clicked without input
  useEffect(() => {
    if (errors?.username) {
      setUserLoginError('')
    }
  }, [errors?.username])
  // Set the room login error message when clicked without input

  useEffect(() => {
    if (errors?.roomCode) {
      setRoomLoginError('')
    }
  }, [errors?.roomCode])

  // Reset the form and clear the roomCode input
  useEffect(() => {
    if (errorMessage) {
      reset({ ...getValues(), roomCode: '' })
      setRoomLoginError('Oda kodu hatalı')
    }
  }, [errorMessage, reset, getValues])
  return (
    <div className="welcome">
      <div className="welcome__login-container">
        <h1>Hoşgeldin!</h1>

        <input
          className="welcome__input--login"
          placeholder="Kullanıcı Adı"
          type="text"
          {...register('username', formSchema.username)}
          style={{
            textAlign: 'center',

            boxSizing: 'border-box',
          }}
        ></input>
        <div className="welcome__login-error-container">
          {(errors?.username || userLoginError) && (
            <p className="welcome__login-error">
              {!errors?.username?.message
                ? userLoginError
                : errors?.username?.message}
            </p>
          )}
        </div>

        <div className="welcome__bottom-container">
          <div className="welcome__bottom-container--left">
            <input
              className="welcome__input--room"
              placeholder="Oda Kodu"
              type="text"
              {...register('roomCode', formSchema.roomCode)}
              style={{
                textAlign: 'center',

                boxSizing: 'border-box',
              }}
            ></input>
            <div className="welcome__login-error-container">
              {(errors?.roomCode || roomLoginError) && (
                <p className="welcome__login-error">
                  {!errors?.roomCode?.message
                    ? roomLoginError
                    : errors?.roomCode?.message}
                </p>
              )}
            </div>
            <div className="welcome__login-button--container">
              <button
                className="welcome__login-button"
                disabled={errors.username || errors.roomCode}
                onClick={handleJoin}
                style={{
                  pointerEvents: (errors.username || errors.roomCode) && 'none',
                }}
              >
                <p>Katıl</p>
              </button>
            </div>
          </div>
          <div className="welcome__bottom-container--right">
            <button
              className="welcome__login-button"
              disabled={errors.username}
              onClick={handleNew}
              style={{
                pointerEvents: errors.username && 'none',
              }}
            >
              <p>Yeni Oda</p>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Welcome
